import CurrencyConversion from '../../Functions/Currency'
export default {
	methods: {
		getDays: function (startDate, endDate) {
			if (startDate === endDate) {
				return 1
			} else {
				var b = this.$moment(endDate)
				var a = this.$moment(startDate)
				var reducedToNights = b.diff(a, 'days') - 1
				if (reducedToNights >= 1) {
					return reducedToNights
				} else {
					return 1
				}
			}
		},
		getCoservationGuests: function () {
			var conservationFees
			if (this.$route.name === 'NewBooking' || this.$route.name === 'EditBooking' || this.$route.name === 'PostponeBooking' || this.$route.name === 'NewPartnerBooking') {
				conservationFees = this.allConservationFees
			} else {
				conservationFees = JSON.parse(localStorage.getItem('conservation_data'))
			}
			var size = conservationFees.length
			var guests = 0
			for (var i = 0; i < size; i++) {
				guests = Number(guests) + Number(conservationFees[i].payment_guests)
			}
			return guests
		},
		getGroupGuests: function () {
			var conservationFees
			if (this.$route.name === 'NewBooking' || this.$route.name === 'NewPartnerBooking' || this.$route.name === 'EditBooking' || this.$route.name === 'PostponeBooking') {
				conservationFees = this.allSchoolConservationFees
			} else {
				conservationFees = JSON.parse(localStorage.getItem('conservation_data'))
			}
			var size = conservationFees.length
			var guests = 0
			for (var i = 0; i < size; i++) {
				guests = Number(guests) + Number(conservationFees[i].payment_guests)
			}
			return guests
		},
		convertConservation: function (data) {
			var total = 0
      total = this.convert1(data.payment_person_currency, data.payment_person_amount).amount * (Number(data.payment_guests) < 0 ? 0 : Number(data.payment_guests))
			if (this.$route.name === 'Reservation' || this.$route.name === 'PaymentInformation') {
				var booking = JSON.parse(localStorage.getItem('user_data'))
				total = total * this.getDays(booking.check_in, booking.check_out)
			}
			return total
		},
		wholeNumber: function (n) {
			return Math.round(n)
		},
		schoolNewConservationTotal: function (conservationDiscount) {
			var conservationFeeDiscount = 0
			if (conservationDiscount === undefined) {
				conservationFeeDiscount = 0
			} else {
				conservationFeeDiscount = Number(conservationDiscount)
			}
			var conservationFees = this.allSchoolConservationFees
			var size = conservationFees.length
			var total = 0
			for (var i = 0; i < size; i++) {
				total = total + this.convert1(conservationFees[i].payment_person_currency, conservationFees[i].payment_person_amount).amount * Number(conservationFees[i].payment_guests) * ((100 - conservationFees[i].payment_person_discount) / 100)
			}
			total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
			if (conservationDiscount > 0) {
				// (100 - 7.05)/100 * 1200
				total = (100 - conservationDiscount) / 100 * total
			}
			return Math.ceil(total)
		},
		removeProof: function (key) {
			var localProof = this.$store.state.ConservationFeeStore.residency_proof
			localProof.splice(key, 1)
			this.$store.commit('PROOF_RESIDENCY', localProof)
		},
		removeProofBookingId: function (key) {
			var localProofBookingId = this.$store.state.ConservationFeeStore.residency_proof_booking_id
			localProofBookingId.splice(key, 1)
			this.$store.commit('PROOF_RESIDENCY_BOOKING_ID_UI', localProofBookingId)

		},
	},
	computed: {
		proofOfResidency: function () {
			return this.$store.state.ConservationFeeStore.conservation_fees_proof;
		},
		proofOfResidencyBookingId: function () {
			return this.$store.state.ConservationFeeStore.residency_proof_booking_id;
		},
		localConservationFees: function () {
			return this.$store.state.ConservationFeeStore.local_conservation
		},
		allConservationFees: function () {

			if (this.$route.name === 'NewBooking') {
				return this.$store.state.ConservationFeeStore.all_conservation_fees
			} else if (
				this.$route.name === "EditBooking" ||
				this.$route.name === "PostponeBooking"
			) {
				this.$store.commit(
					"UPDATE_CONSERVATION_FEES",
					this.$store.state.BookingStore.booking.guests
				);
				return this.$store.state.ConservationFeeStore
					.all_conservation_fees;
			}

			else {
				return this.$store.state.ConservationFeeStore
					.all_conservation_fees;
			}
		},
		allChildrenConservationFees: function () {
			let allConservancyFee = this.allConservationFees

			let childConservancyFee = allConservancyFee.filter(
				fee => fee.marker === "Child - C"
			);
			if(childConservancyFee ==[]){
				childConservancyFee =this.allSchoolConservationFees.filter(
					fee => fee.marker === "Child - C"
				);

			}

			

			return childConservancyFee;
		},
		allAdultConservationFees: function () {

			let allConservancyFee = this.allConservationFees
		
			let adultConservancyFee = allConservancyFee.filter(
				fee => fee.marker === "Adult - A"
			);

			if(adultConservancyFee ==[]){
				 adultConservancyFee = this.allSchoolConservationFees.filter(
					fee => fee.marker === "Adult - A");

			}

			return adultConservancyFee;
		},
		allSchoolConservationFees: function () {
			if (this.$route.name === 'EditBooking' || this.$route.name === 'PostponeBooking') {
				this.$store.commit('UPDATE_ALL_CONSERVATION_FEES', this.$store.state.BookingStore.booking.guests)
				return this.$store.state.ConservationFeeStore.all_school_conservation_fees
			} else {
				return this.$store.state.ConservationFeeStore.all_school_conservation_fees
			}
		},
		allFullConservationFees: function () {
			return this.$store.state.ConservationFeeStore.all_full_conservation_fees
		},

		conservationFeesProofData: function () {
			let residency_fees = this.allConservationFees;
			let residency_fees_partners = this.allSchoolConservationFees

			let inventory_data = this.chosenInventory;
			let to_include_residency = [];
			let resultList = []
			if (this.$route.name === 'EditBooking') {
				if (residency_fees != undefined && residency_fees.length > 0) {
					for (let i = 0; i < residency_fees.length; i++) {
						if (
							residency_fees[i].residency_proof &&
							residency_fees[i].payment_guests > 0
						) {
							for (let r = 0; r < residency_fees[i].payment_guests; r++) {

								let residency_fees_obj = {

									"payment_person": residency_fees[i].payment_person,
									"payment_public_id": residency_fees[i].payment_public_id,
									"proof_point": 'Residency',
									"first_name": "",
									"last_name": "",
									"document_id": ""

								}
								to_include_residency.push(residency_fees_obj);

							}

						}
					}
				}
			}

			else {
				if (residency_fees != undefined && residency_fees.length > 0) {

					for (let i = 0; i < residency_fees.length; i++) {
						if (
							residency_fees[i].residency_proof &&
							residency_fees[i].payment_guests > 0
						) {
							for (let r = 0; r < residency_fees[i].payment_guests; r++) {

								let residency_fees_obj = {

									"payment_person": residency_fees[i].payment_person,
									"payment_public_id": residency_fees[i].payment_public_id,
									"proof_point": 'Residency',
									"first_name": "",
									"last_name": "",
									"document_id": ""

								}
								to_include_residency.push(residency_fees_obj);

							}

						}
					}
				}
				if (residency_fees_partners != undefined && residency_fees_partners.length > 0) {
					for (let j = 0; j < residency_fees_partners.length; j++) {
						if (
							residency_fees_partners[j].residency_proof &&
							residency_fees_partners[j].payment_guests > 0
						) {
							for (let s = 0; s < residency_fees_partners[j].payment_guests; s++) {

								let residency_fees_obj = {
									"payment_person": residency_fees_partners[j].payment_person,
									"payment_public_id": residency_fees_partners[j].payment_public_id,
									"proof_point": 'Residency',
									"first_name": "",
									"last_name": "",
									"document_id": ""

								}
								to_include_residency.push(residency_fees_obj);
							}

						}
					}
				}
			}
			if (inventory_data.length > 0) {
				for (let k = 0; k < inventory_data.length; k++) {
					let inventory = inventory_data[k];

					if (Object.keys(inventory.residency_children).length != 0 && inventory.residency_children.residency_proof) {
						for (let a = 0; a < inventory.children; a++) {
							let residency_fees_obj = {
								"payment_person": inventory.residency_children.payment_person,
								"payment_public_id": inventory.residency_children.payment_public_id,
								"proof_point": inventory.name,
								"first_name": "",
								"last_name": "",
								"document_id": ""
							}
							to_include_residency.push(residency_fees_obj);
						}
					}
					if (Object.keys(inventory.residency_adult).length != 0 && inventory.residency_adult.residency_proof) {
						for (let c = 0; c < inventory.adults; c++) {
							let residency_fees_obj = {
								"payment_person": inventory.residency_adult.payment_person,
								"payment_public_id": inventory.residency_adult.payment_public_id,
								"proof_point": inventory.name,
								"first_name": "",
								"last_name": "",
								"document_id": ""

							}
							to_include_residency.push(residency_fees_obj);
						}
					}
				}
			}


			if (this.$route.name === 'EditBooking') {
				let proofed = this.$store.state.ConservationFeeStore.proofed_residency
				if (proofed != undefined && proofed.length > 0) {
					let new_proofed = []
					for(let h = 0; h<proofed.length; h++){

						let residency_fees_obj = {

							"payment_person": proofed[h].residency.payment_person,
							"payment_public_id": proofed[h].residency.payment_public_id,
							"proof_point": proofed[h].proof_point,
							"first_name": proofed[h].first_name,
							"last_name": proofed[h].last_name,
							"document_id": proofed[h].document_id,
							"residency_proof_public_id": proofed[h].residency_proof_public_id,

						}
						new_proofed.push(residency_fees_obj);

					}
					for (let r = 0; r < to_include_residency.length; r++) {
						let found = false
						let index = 0
						for (let b = 0; b < new_proofed.length; b++) {
							let proofed_id = new_proofed[b].payment_public_id
							if (to_include_residency[r].payment_public_id == proofed_id) {
								found = true
								index = b
							}
						}
						if(found){
							resultList.push(new_proofed[index])
							new_proofed.splice(index, 1);

						}else{
							resultList.push(to_include_residency[r])
						}
					}
					to_include_residency =[]
					to_include_residency = resultList
				}
			}
			to_include_residency.sort((a, b) => a.payment_person.localeCompare(b.payment_person))
			this.$store.commit("CONSERVATION_FEES_PROOF", to_include_residency);
			// return to_include_residency;

		},
		allFullConservationSchedule: function () {
			return this.$store.state.ConservationFeeStore.all_conservation_fees_schedule
		},

		schoolConservationTotal: function () {
			var conservationFees = this.allSchoolConservationFees
			var size = conservationFees.length
			var total = 0
			for (var i = 0; i < size; i++) {
				total = total + this.convert1(conservationFees[i].payment_person_currency, conservationFees[i].payment_person_amount).amount * Number(conservationFees[i].payment_guests) * ((100 - conservationFees[i].payment_person_discount) / 100)
			}
			total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
			return total
		},
		conservationTotal: function () {
			var conservationFees
			if (this.$route.name === 'NewBooking') {
				conservationFees = this.allConservationFees
			} else {
				localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
				conservationFees = JSON.parse(localStorage.getItem('conservation_data'))
			}
			var size = conservationFees.length
			var total = 0
			for (var i = 0; i < size; i++) {
				// total = total + this.convert1(conservationFees[i].payment_person_currency, conservationFees[i].payment_person_amount).amount * Number(conservationFees[i].payment_guests) * ((100 - conservationFees[i].payment_person_discount) / 100)
				total = total + Math.ceil(Math.ceil((this.convert1(conservationFees[i].payment_person_currency, conservationFees[i].payment_person_amount).amount).toFixed(2)) * Number(conservationFees[i].payment_guests) * ((100 - conservationFees[i].payment_person_discount) / 100))
			}
			var booking = JSON.parse(localStorage.getItem('user_data'))
			switch (this.$route.name) {
				case 'Reservation':
					total = total * this.getDays(booking.check_in, booking.check_out)
					break
				case 'PaymentInformation':
					total = total * this.getDays(booking.check_in, booking.check_out)
					break
				case 'NewBooking':
					total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
					break
				case 'NewPartnerBooking':
					total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
					break
				case 'EditBooking':
					total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
					break
				case 'PostponeBooking':
					total = total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out)
					break
			}

			return total
		},
		conservationFeeDiscount: function () {
			var conservationFeeDiscount
			conservationFeeDiscount = (this.conservation_fee_discount / 100) * Number(this.conservationTotal)
			return conservationFeeDiscount
		},
		conservationDifference: function () {
			var conservationDifference
			conservationDifference = this.conservationTotal - this.conservationFeeDiscount
			return conservationDifference
		},
		conservationGuests: function () {
			var conservationFees = this.allConservationFees
			var size = conservationFees.length
			var total = 0
			for (var i = 0; i < size; i++) {
				total = total + Number(conservationFees[i].payment_guests)
			}
			return total
		}
	},
	mixins: [CurrencyConversion]
}
